const avisoAutocheckInitialState = {
  avisoAutocheck: {
    show: false,
  },
};

export default avisoAutocheckInitialState;
